function cleanString(stringToClear) {
  var lowerCase = stringToClear.toLowerCase();
  var withoutPoctuation = lowerCase.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return withoutPoctuation;
}
export { cleanString };